import React from 'react';
import './HaveListAlertBell.css';

const ICON_ACTIVE = 'https://trademagic-assets.s3.us-west-1.amazonaws.com/assets/icons/notifications_active_24dp.svg';
const ICON_PAUSED = 'https://trademagic-assets.s3.us-west-1.amazonaws.com/assets/icons/notifications_paused_24dp.svg';

interface HaveListAlertBellProps {
  enabled: boolean;
  phoneVerified: boolean;
  cardName: string;
  onToggle: (enable: boolean) => void;
  disabled?: boolean;
}

export const HaveListAlertBell: React.FC<HaveListAlertBellProps> = ({
  enabled,
  phoneVerified,
  cardName,
  onToggle,
  disabled = false,
}) => {
  const classes = [
    'have-list-alert-toggle',
    enabled ? 'active' : '',
    !phoneVerified ? 'unverified' : '',
  ]
    .filter(Boolean)
    .join(' ');

  const title = !phoneVerified
    ? 'Verify phone to enable alerts'
    : enabled
      ? 'SMS alerts on'
      : 'SMS alerts off';

  const iconUrl = enabled ? ICON_ACTIVE : ICON_PAUSED;

  return (
    <div
      className="collection-card-alert-toggle"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className={classes}
        onClick={(e) => {
          e.stopPropagation();
          onToggle(!enabled);
        }}
        aria-pressed={enabled}
        aria-label={`Enable SMS alerts for ${cardName}`}
        title={title}
        disabled={disabled}
      >
        <img
          src={iconUrl}
          alt=""
          aria-hidden="true"
          width={14}
          height={14}
          className="have-list-alert-toggle__icon"
        />
      </button>
    </div>
  );
};

export default HaveListAlertBell;
